import { db, storage } from "./Firebase";
import "firebase/firestore";
import _, { map, size, isEmpty } from "lodash";
import uuid from "random-uuid-v4";
import moment from "moment";
import sound from "../notification.mp3";

const audio = new Audio(sound);

//firebase.firestore.setLogLevel('debug');
//const fireSQL = new FireSQL(firebase.firestore(), {includeId: 'id'});

export const addRegistroEspecifico = async (coleccion, doc, data) => {
  const resultado = { error: "", statusresponse: false };

  await db
    .collection(coleccion)
    .doc(doc)
    .set(data, { merge: true })
    .then((response) => {
      resultado.statusresponse = true;
    })
    .catch((err) => {
      resultado.error = err;
    });

  return resultado;
};

export const addRegistro = async (colecion, data) => {
  const resultado = { error: "", data: "", statusresponse: false };

  await db
    .collection(colecion)
    .add(data)
    .then((response) => {
      resultado.data = response.id;
      resultado.statusresponse = true;
    })
    .catch((err) => {
      console.log(err);
      resultado.error = err;
    });

  return resultado;
};

export const subirImagenesBatch = async (imagenes, ruta) => {
  const imagenesurl = [];

  await Promise.all(
    map(imagenes, async (image) => {
      console.log("AQUÍ ESTA LA IMAGEN");
      console.log(image);
      const ref = storage.ref(ruta).child(uuid());
      await ref.put(image).then(async (result) => {
        console.log("SUBIO LA IMAGEN");
        await storage
          .ref(`${ruta}/${result.metadata.name}`)
          .getDownloadURL()
          .then((imagenurl) => {
            imagenesurl.push(imagenurl);
          });
      });
    })
  );

  return imagenesurl;
};

export const getEmployeeNumber = async () => {
  let response = { statusresponse: false, data: 0 };
  const ref = db.collection("Documents").doc("Sw4FFkLrdTi4slNLF9kn");

  await ref.get().then((result) => {
    response.data = _.get(result.data(), "IDEMPLEADO", "");
    response.statusresponse = true;
  });
  ref.update({ IDEMPLEADO: response.data + 1 });
  return response;
};

export const getUsuerById = async (id) => {
  let response = { statusresponse: false, data: null };
  const ref = db.collection("Usuarios").doc(id);

  await ref.get().then((result) => {
    response.data = result.data();
    response.statusresponse = true;
  });
  if (size(response.data) > 0) {
    response.statusresponse = true;
  } else {
    response.statusresponse = false;
  }
  return response;
};

export const getIncidentsById = async (id) => {
  let response = { statusresponse: false, data: null };
  const ref = db.collection("Incidents").doc(id);

  await ref.get().then((result) => {
    response.data = result.data();
    response.statusresponse = true;
  });
  if (size(response.data) > 0) {
    response.statusresponse = true;
  } else {
    response.statusresponse = false;
  }
  return response;
};

export const getHistoryById = async (id) => {
  let response = { statusresponse: false, data: null };
  const ref = db.collection("History").doc(id);

  await ref.get().then((result) => {
    response.data = result.data();
    response.data.createdAt = response.data.createdAt.toDate();
    response.statusresponse = true;
  });
  if (size(response.data) > 0) {
    response.statusresponse = true;
  } else {
    response.statusresponse = false;
  }
  return response;
};

export const getRequestssById = async (id) => {
  let response = { statusresponse: false, data: null };
  const ref = db.collection("Requests").doc(id);

  await ref.get().then((result) => {
    response.data = result.data();
    response.statusresponse = true;
  });
  if (size(response.data) > 0) {
    response.statusresponse = true;
  } else {
    response.statusresponse = false;
  }
  return response;
};

export const getAllUsers = async () => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Usuarios")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const usuarios = doc.data();
        usuarios.id = doc.id;
        response.data.push(usuarios);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
};

export const obternerRegistroxID = async (coleccion, documento) => {
  let response = { statusresponse: false, data: null };

  await db
    .collection(coleccion)
    .doc(documento)
    .get()
    .then((result) => {
      const visita = result.data();
      visita.id = result.id;
      response.data = visita;
      response.statusresponse = true;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
};

export const actualizarRegistro = async (coleccion, documento, data) => {
  let response = { statusresponse: false };

  await db
    .collection(coleccion)
    .doc(documento)
    .update(data)
    .then((result) => (response.statusresponse = true))
    .catch((err) => console.log(err));

  return response;
};

export const ListarLocalidad = async () => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Accounts")
    .where("status", "==", true)
    .orderBy("name")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const account = doc.data();
        account.id = doc.id;
        response.data.push(account);
      });
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const getDevicexLocation = async (deviceid) => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("LocationxDevice")
    .where("deviceid", "==", deviceid.trim())
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const devicelocation = doc.data();
        devicelocation.id = doc.id;
        response.data.push(devicelocation);
      });
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const getUserByCode = async (numbercode) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .where("employeenumber", "==", Number(numbercode))
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const getCustomers = async (accoundid) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .where("rol", "==", 4)
    .where("accountAsigned", "==", accoundid)
    .where("status", "==", true)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const getAdminUsers = async (accoundid) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .where("rol", "==", 3)
    .where("status", "==", true)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const getUsersList = async () => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;
        usuario.createdAt = usuario.createdAt.toDate();
        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const getUserByEmail = async (email) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .where("email", "==", email)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const loadAccountList = async (email) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Accounts")
    .where("status", "==", true)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const loadAccountListAll = async () => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Accounts")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const signInWeb = async (user, password) => {
  let response = { statusresponse: false, data: [] };
  let usuario;
  await db
    .collection("Usuarios")
    .where("userweb", "==", user)
    .where("passwordweb", "==", password)
    .where("status", "==", true)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        usuario = doc.data();
        usuario.id = doc.id;

        response.data.push(usuario);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((ex) => {
      console.log("Error" + ex);
    });
  return response;
};

export const assistancePending = async (userid) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Assistance")
    .where("user", "==", userid)
    .where("status", "==", 0)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const assistanceTotal = async (userid) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Assistance")
    .where("status", "==", 0)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const assistanceTotalCustomers = async (userid) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Assistance")
    .where("status", "==", 0)
    .where("accountId", "==", userid)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const incidentsPending = async () => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Incidents")
    .limit(50)
    .orderBy("createdAt", "desc")

    // .where("status", "==", 1) // falta estatus
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const incidentsPendingxFecha = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Incidents")
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    // .where("status", "==", 1) // falta estatus
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const incidentsPendingDashboard = async () => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Incidents")
    .where("descriptionadmin", "==", "") // falta estatus completado
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const incidentsPendingClient = async (clilentid) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Incidents")
    .where("accountId", "==", clilentid)
    .where("sent", "==", true)
    .limit(50)
    .orderBy("createdAt", "desc")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((err) => {
      console.log(err);
    });
  return response;
};

export const incidentsPendingClientDashboard = async (clilentid) => {
  let response = { statusresponse: false, data: [] };
  var dayinit = new Date();
  dayinit.setHours(0, 0, 0, 0);
  await db
    .collection("Incidents")
    .where("accountId", "==", clilentid)
    .where("createdAt", ">", dayinit)
    .where("sent", "==", true)
    .limit(50)
    .orderBy("createdAt", "desc")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    })
    .catch((err) => {
      console.log(err);
    });
  return response;
};

export const incidentsPendingClientxFecha = async (
  clilentid,
  fechaini,
  fechafin
) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Incidents")
    .where("accountId", "==", clilentid)
    .where("sent", "==", true)
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        asistencia.createdAt = asistencia.createdAt.toDate();
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const getLogHistory = async (clilentid) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("History")
    .orderBy("createdAt", "desc")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let history = doc.data();
        history.id = doc.id;
        history.createdAt = history.createdAt.toDate();
        response.data.push(history);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const getLogHistoryxFecha = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("History")
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let history = doc.data();
        history.id = doc.id;
        history.createdAt = history.createdAt.toDate();
        response.data.push(history);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const RequestsQuery = async () => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Requests")
    .orderBy("createdAt", "desc")
    .limit(50)
    // .where("status", "==", 0) falta estatus
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let requests = doc.data();
        requests.id = doc.id;
        requests.createdAt = requests.createdAt.toDate();
        response.data.push(requests);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const RequestsQueryFilter = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Requests")
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    // .where("status", "==", 0) falta estatus
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let requests = doc.data();
        requests.id = doc.id;
        requests.createdAt = requests.createdAt.toDate();
        response.data.push(requests);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const getVisitByIdentification = async (identification) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Visits")
    .where("identification", "==", identification)
    .orderBy("createdAt", "desc")
    .limit(1)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const getVisits = async (identification) => {
  let response = { statusresponse: false, data: [] };
  await db
    .collection("Visits")
    .where("identification", "==", identification)
    .orderBy("createdAt", "desc")
    .limit(1)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        let asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });
      if (size(response.data) > 0) {
        response.statusresponse = true;
      } else {
        response.statusresponse = false;
      }
    });
  return response;
};

export const ListarVisitas = async () => {
  let response = { statusresponse: false, data: [] };
  let beginningDate = Date.now() - 604800000;
  let beginningDateObject = new Date(beginningDate);

  await db
    .collection("Visits")
    // .where("createdAt", ">", beginningDateObject)
    .orderBy("createdAt", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const visita = doc.data();
        visita.id = doc.id;
        visita.createdAt = moment(visita.createdAt.toDate()).format("lll");
        if (!isEmpty(visita.updatedAt)) {
          visita.updatedAt = moment(visita.updatedAt.toDate()).format("lll");
        }
        response.data.push(visita);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarVisitasxFecha = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };
  let beginningDate = Date.now() - 604800000;
  let beginningDateObject = new Date(beginningDate);

  await db
    .collection("Visits")
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const visita = doc.data();
        visita.id = doc.id;
        visita.createdAt = moment(visita.createdAt.toDate()).format("lll");
        if (!isEmpty(visita.updatedAt)) {
          visita.updatedAt = moment(visita.updatedAt.toDate()).format("lll");
        }
        response.data.push(visita);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarVisitasCliente = async (clientid) => {
  let response = { statusresponse: false, data: [] };
  let beginningDate = Date.now() - 604800000;
  let beginningDateObject = new Date(beginningDate);

  await db
    .collection("Visits")
    .where("accountId", "==", clientid)
    //.startAt(beginningDateObject)
    .orderBy("createdAt", "desc")

    .get()

    .then((result) => {
      result.forEach((doc) => {
        const visita = doc.data();
        visita.id = doc.id;
        visita.createdAt = moment(visita.createdAt.toDate()).format("lll");
        visita.updatedAt = moment(visita.updatedAt.toDate()).format("lll");
        response.data.push(visita);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarVisitasClientexFecha = async (
  clientid,
  fechaini,
  fechafin
) => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Visits")
    .where("accountId", "==", clientid)
    .where("createdAt", ">", fechaini)
    .where("createdAt", "<", fechafin)
    .orderBy("createdAt", "desc")
    .get()

    .then((result) => {
      result.forEach((doc) => {
        const visita = doc.data();
        visita.id = doc.id;
        visita.createdAt = moment(visita.createdAt.toDate()).format("lll");
        visita.updatedAt = moment(visita.updatedAt.toDate()).format("lll");
        response.data.push(visita);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarVisitasDashboard = async (clientid) => {
  let response = { statusresponse: false, data: [] };
  var dayinit = new Date();
  dayinit.setHours(0, 0, 0, 0);
  console.log(dayinit);

  await db
    .collection("Visits")
    .where("accountId", "==", clientid)
    .where("createdAt", ">", dayinit)
    .orderBy("createdAt", "desc")

    .get()

    .then((result) => {
      result.forEach((doc) => {
        const visita = doc.data();
        visita.id = doc.id;
        visita.createdAt = moment(visita.createdAt.toDate()).format("lll");
        visita.updatedAt = moment(visita.updatedAt.toDate()).format("lll");
        response.data.push(visita);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarAsistencia = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };
  let beginningDate = new Date(fechaini) - 604800000;
  let beginningDateObject = new Date(beginningDate);

  await db
    .collection("Assistance")
    .where("registerday", ">=", new Date(fechaini))
    .where("registerday", "<=", new Date(fechafin))
    .orderBy("registerday")

    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarReclamosAdmin = async () => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Claims")
    .limit(50)
    .orderBy("fecha", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarReclamosAdminxFecha = async (fechaini, fechafin) => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Claims")
    .where("updatedAt", ">", fechaini)
    .where("updatedAt", "<", fechafin)
    .orderBy("updatedAt", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarReclamosCustomer = async (client) => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Claims")
    .where("accountAsigned", "==", client)
    .limit(50)
    .orderBy("updatedAt", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const ListarReclamosCustomerxFecha = async (
  client,
  fechaini,
  fechafin
) => {
  let response = { statusresponse: false, data: [] };

  await db
    .collection("Claims")
    .where("accountAsigned", "==", client)
    .where("updatedAt", ">", fechaini)
    .where("updatedAt", "<", fechafin)
    .orderBy("updatedAt", "desc")
    //.startAt(beginningDateObject)
    .get()
    .then((result) => {
      result.forEach((doc) => {
        const asistencia = doc.data();
        asistencia.id = doc.id;
        response.data.push(asistencia);
      });

      if (size(response.data) > 0) {
        response.statusresponse = true;
      }
    })
    .catch((err) => console.log(err));
  //Ordernar por fecha y por dia
  return response;
};

export const countIncidents = (setchange, setincidentes) => {
  let response = { data: 0 };
  return new Promise(async (resolve, reject) => {
    await db
      .collection("Incidents")
      .where("viewed", "==", 0)
      .onSnapshot(
        (docSnapshot) => {
          docSnapshot.docChanges().forEach((change) => {
            console.log("change");
            console.log(change);
            if (change.type === "added") {
              response.data = response.data + 1;
              if (Number(response.data) > 0) {
                if (!audio.isPlaying) {
                  console.log("ENTRO AL AUDIO LOCO");
                  audio.play();
                }
              }
            }
          });
          setchange(true);
          setincidentes(response.data);
          return resolve(response.data);
        },
        (error) => {
          reject(0);
        }
      );
    return response;
  });
};

export const countReclamos = (setchange, setreclamos) => {
  let response = { data: 0 };
  return new Promise(async (resolve, reject) => {
    await db
      .collection("Claims")
      .where("viewed", "==", 0)
      .onSnapshot(
        (docSnapshot) => {
          docSnapshot.docChanges().forEach((change) => {
            console.log("change");
            console.log(change);
            if (change.type === "added") {
              response.data = response.data + 1;
              if (Number(response.data) > 0) {
                if (!audio.isPlaying) {
                  console.log("ENTRO AL AUDIO LOCO");
                  audio.play();
                }
              }
            }
          });
          setchange(true);
          setreclamos(response.data);
          return resolve(response.data);
        },
        (error) => {
          reject(0);
        }
      );
    return response;
  });
};

export const countSolicitudes = (setchange, setsolicitudes) => {
  let response = { data: 0 };
  return new Promise(async (resolve, reject) => {
    await db
      .collection("Requests")
      .where("viewed", "==", 0)
      .onSnapshot(
        (docSnapshot) => {
          docSnapshot.docChanges().forEach((change) => {
            console.log("change");
            console.log(change);
            if (change.type === "added") {
              response.data = response.data + 1;
              if (Number(response.data) > 0) {
                if (!audio.isPlaying) {
                  console.log("ENTRO AL AUDIO LOCO");
                  audio.play();
                }
              }
            }
          });
          setchange(true);
          setsolicitudes(response.data);
          return resolve(response.data);
        },
        (error) => {
          reject(0);
        }
      );
    return response;
  });
};

export const countAssistance = (setchange, setasistencias) => {
  let response = { data: 0 };
  return new Promise(async (resolve, reject) => {
    await db
      .collection("Assistance")
      .where("viewed", "==", 0)
      .limit(50)
      .onSnapshot(
        (docSnapshot) => {
          docSnapshot.docChanges().forEach((change) => {
            console.log("change");
            console.log(change);
            if (change.type === "added") {
              response.data = response.data + 1;
              if (Number(response.data) > 0) {
                if (!audio.isPlaying) {
                  console.log("ENTRO AL AUDIO LOCO");
                  audio.play();
                }
              }
            }
          });
          setchange(true);
          setasistencias(response.data);
          return resolve(response.data);
        },
        (error) => {
          reject(0);
        }
      );
    return response;
  });
};

export const updateIncidentsViewed = async () => {
  let response = { statusresponse: false };
  let documento = "";
  await db
    .collection("Incidents")
    .where("viewed", "==", 0)
    .get()
    .then((result) =>
      result.forEach(async (doc) => {
        documento = doc.id;
        await actualizarRegistro("Incidents", documento, { viewed: 1 });
      })
    )
    .catch((err) => console.log(err));

  return response;
};

export const updateReclamosViewed = async () => {
  let response = { statusresponse: false };
  let documento = "";
  await db
    .collection("Claims")
    .where("viewed", "==", 0)
    .get()
    .then((result) =>
      result.forEach(async (doc) => {
        documento = doc.id;
        await actualizarRegistro("Claims", documento, { viewed: 1 });
      })
    )
    .catch((err) => console.log(err));

  return response;
};

export const updateSolicitudesViewed = async () => {
  let response = { statusresponse: false };
  let documento = "";
  await db
    .collection("Requests")
    .where("viewed", "==", 0)
    .get()
    .then((result) =>
      result.forEach(async (doc) => {
        documento = doc.id;
        await actualizarRegistro("Requests", documento, { viewed: 1 });
      })
    )
    .catch((err) => console.log(err));

  return response;
};

export const updateAssistance = async () => {
  let response = { statusresponse: false };
  let documento = "";
  await db
    .collection("Assistance")
    .where("viewed", "==", 0)
    .get()
    .then((result) =>
      result.forEach(async (doc) => {
        documento = doc.id;
        await actualizarRegistro("Assistance", documento, { viewed: 1 });
      })
    )
    .catch((err) => console.log(err));

  return response;
};
